// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TitleBar_Header__mZz5T {
  overflow: hidden;
  background: linear-gradient(to right, #44aa99 0%, #332288 100%);
  /* background: linear-gradient(to right, #44aa99 0%, #332288 100%); */
  /* background: #0072C6; */
  padding: 3px 0px;
  font-family: "IBM Plex Sans", sans-serif !important;
}

.TitleBar_BlackButton__DbhZr {
  background: transparent;
  border: 0px solid #000000;
}

.TitleBar_BlackButton__DbhZr:hover {
  background: #332288;
  border: 0px solid #000000;
}

.TitleBar_Header__mZz5T a {
  float: left;
  color: white;
  text-align: center;
  padding: 12px;
  text-decoration: none;
  font-size: 15px;
  line-height: 10px;
  border-radius: 4px;
}

.TitleBar_Header__mZz5T a.TitleBar_logo__nF77d {
  font-size: 20px;
  font-weight: 100 !important;
}

.TitleBar_Header__mZz5T a:hover {
  background-color: #ddd;
  color: black;
}

.TitleBar_Header__mZz5T a.TitleBar_active__xd7iW {
  background-color: #28477f;
  color: white;
}

.TitleBar_HeaderRight__63p6h {
  float: right;
}

.TitleBar_LogoText__-1Q02 {
  float: left;
  color: white;
  text-align: center;
  padding-left: 20px;
  padding-right: 40px;
  text-decoration: none;
  font-size: 25px;
  line-height: 10px;
  font-weight: 400;
}

.TitleBar_Colorized__VwL2b {
  padding: 10px;
  text-align: center;
  background: linear-gradient(to right, #30cfd0 0%, #332288 100%);
  line-height: 10px;
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

.TitleBar_Push__0BhDC {
  margin-left: auto;
}
@media screen and (max-width: 500px) {
  .TitleBar_Header__mZz5T a {
    float: none;
    display: block;
    text-align: left;
  }

  .TitleBar_HeaderRight__63p6h {
    float: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/layout/TitleBar/TitleBar.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,+DAA+D;EAC/D,qEAAqE;EACrE,yBAAyB;EACzB,gBAAgB;EAChB,mDAAmD;AACrD;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,qBAAqB;EACrB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,+DAA+D;EAC/D,iBAAiB;EACjB,6BAA6B;EAC7B,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE;IACE,WAAW;IACX,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":[".Header {\n  overflow: hidden;\n  background: linear-gradient(to right, #44aa99 0%, #332288 100%);\n  /* background: linear-gradient(to right, #44aa99 0%, #332288 100%); */\n  /* background: #0072C6; */\n  padding: 3px 0px;\n  font-family: \"IBM Plex Sans\", sans-serif !important;\n}\n\n.BlackButton {\n  background: transparent;\n  border: 0px solid #000000;\n}\n\n.BlackButton:hover {\n  background: #332288;\n  border: 0px solid #000000;\n}\n\n.Header a {\n  float: left;\n  color: white;\n  text-align: center;\n  padding: 12px;\n  text-decoration: none;\n  font-size: 15px;\n  line-height: 10px;\n  border-radius: 4px;\n}\n\n.Header a.logo {\n  font-size: 20px;\n  font-weight: 100 !important;\n}\n\n.Header a:hover {\n  background-color: #ddd;\n  color: black;\n}\n\n.Header a.active {\n  background-color: #28477f;\n  color: white;\n}\n\n.HeaderRight {\n  float: right;\n}\n\n.LogoText {\n  float: left;\n  color: white;\n  text-align: center;\n  padding-left: 20px;\n  padding-right: 40px;\n  text-decoration: none;\n  font-size: 25px;\n  line-height: 10px;\n  font-weight: 400;\n}\n\n.Colorized {\n  padding: 10px;\n  text-align: center;\n  background: linear-gradient(to right, #30cfd0 0%, #332288 100%);\n  line-height: 10px;\n  -webkit-background-clip: text;\n  background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n.Push {\n  margin-left: auto;\n}\n@media screen and (max-width: 500px) {\n  .Header a {\n    float: none;\n    display: block;\n    text-align: left;\n  }\n\n  .HeaderRight {\n    float: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Header": `TitleBar_Header__mZz5T`,
	"BlackButton": `TitleBar_BlackButton__DbhZr`,
	"logo": `TitleBar_logo__nF77d`,
	"active": `TitleBar_active__xd7iW`,
	"HeaderRight": `TitleBar_HeaderRight__63p6h`,
	"LogoText": `TitleBar_LogoText__-1Q02`,
	"Colorized": `TitleBar_Colorized__VwL2b`,
	"Push": `TitleBar_Push__0BhDC`
};
export default ___CSS_LOADER_EXPORT___;
